import { RootLayout } from '../core/root-layout';
import { AuditLogRoute } from './audit-log.route';
import { CustomersRoute } from './customers.route';
import { DashboardRoute } from './dashboard.route';
import { InspectorCalendarRoute } from './inspector-calendar.route';
import { MastersRoute } from './masters.route';
import { OfficesRoute } from './office.route';
import { OperationManagementRoute } from './operation-management.route';
import { PlanLibraryRoute } from './plan-library.route';
import { ProjectsRoute } from './projects.route';
import { SchedulingRoute } from './scheduling.route';
import { UnitsRoute } from './units.route';
import { WorkorderReportRoute } from './workorder-report.route';
import { WorkOrdersRoute } from './workorders.route';
import { ResetPasswordRoute } from './reset-password.route';
import { InvoiceReportRoute } from './invoice-report.route';
import { Navigate } from 'react-router-dom';
import { WorkorderInspectionReportRoute } from './workorder-inspection-report.route';
import { DUXInspectionRequestRoute } from './dux-inspection-request.route';
import { InvoiceExceptionReportRoute } from './invoice-exception-report.route';
import { isDesktop } from 'react-device-detect';
import { QueryBuilderRoute } from './query-builder.route';
import { PlanReviewsRoute } from './plans-reviews.route';
import { EmployeeProfileRoute } from './employee-profile.route';
import { ScheduleDragAndDrop } from '../features/schedule-drag-and-drop/schedule-drag-and-drop';
import { SchedulingDragAndDropRoute } from './schedule-drag-and-drop.route';
import { BillingReportRoute } from './billing-report.route';
import { CocRoute } from './coc.route';
import { CocBillingReportRoute } from './coc-billing-report.route';
import { FastFieldReprocessQueueRoute } from './fast-field-reprocess-queue.route';

const isMobileViewEnabled = process.env.REACT_APP_MOBILE_VIEW_FLAG === 'true';

export const AppRoutes = [
  {
    path: '/',
    element: <RootLayout />,
    children:
      isDesktop || !isMobileViewEnabled
        ? [
            DashboardRoute,
            MastersRoute,
            CustomersRoute,
            OfficesRoute,
            ProjectsRoute,
            UnitsRoute,
            PlanReviewsRoute,
            WorkOrdersRoute,
            OperationManagementRoute,
            SchedulingRoute,
            PlanLibraryRoute,
            WorkorderReportRoute,
            AuditLogRoute,
            InspectorCalendarRoute,
            ResetPasswordRoute,
            InvoiceReportRoute,
            WorkorderInspectionReportRoute,
            DUXInspectionRequestRoute,
            InvoiceExceptionReportRoute,
            QueryBuilderRoute,
            EmployeeProfileRoute,
            SchedulingDragAndDropRoute,
            BillingReportRoute,
            CocRoute,
            CocBillingReportRoute,
            FastFieldReprocessQueueRoute,
            {
              path: '*',
              element: <Navigate to="/" replace />,
            },
          ]
        : [DashboardRoute, InspectorCalendarRoute, ResetPasswordRoute],
  },
];
